// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1TZan","signatureBlock":"Footer_signatureBlock__2AVGh","signature":"Footer_signature__v5Ghf"};